// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"6f8faf5a","121":"9d341f92","399":"df27969e","570":"bf1353ae","584":"58a0e543","594":"ed0160ec"}[chunkId] + ".chunk.css";
};